const client = {
  id: null,
  businessEntityId: null,
  active: null,
  name: null,
  createdBy: null,
  invoiceFrequencyId: null,
  invoiceFrequencyName: null,
  thirdPartyPortalId: 1,
  clientStakeholderRecipients: [],
  vmsFee: null,
  contractorExpenses: [],
  directPlacementsExpenses: [],
  useStaffLynxForTimeEntering: false,
  clientOfRecord: false,
  quickBooksCustomerId: null,
  quickBooksTimesheetItemId: null,
  postToQuickBooksAutomatically: false
}

export default () => Object.assign({}, client)
